import { DateTime } from 'luxon';
import tzdata from 'tzdata';

const priorTimeZones: string[] = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
];

const listOfValidTimeZones: string[] = Object.entries(tzdata.zones)
  .filter(([zoneName, v]) => Array.isArray(v))
  .map(([zoneName, v]) => zoneName)
  .filter((tz) => DateTime.local().setZone(tz).isValid);

export const getListOfValidTimezones: string[] = listOfValidTimeZones.toSorted((a, b) => {
  if (!priorTimeZones.includes(a) && priorTimeZones.includes(b)) return 1;
  if (priorTimeZones.includes(a) && !priorTimeZones.includes(b)) return -1;
  if (priorTimeZones.includes(a) && priorTimeZones.includes(b))
    return priorTimeZones.indexOf(a) - priorTimeZones.indexOf(b);
  return DateTime.local().setZone(a).offset - DateTime.local().setZone(b).offset;
});

export const getOffsetName = (timeZone: string): string => {
  const dateInTimeZone = DateTime.local().setZone(timeZone);
  const isValid = timeZone && dateInTimeZone.isValid;
  const offset = isValid ? dateInTimeZone.offset / 60 : 0;
  return timeZone && dateInTimeZone.isValid
    ? `${dateInTimeZone.offsetNameShort} (GMT${offset < 0 ? '' : '+'}${offset})`
    : '';
};

export const getSimpleOffsetName = (timeZone: string): string => {
  const dateInTimeZone = DateTime.local().setZone(timeZone);
  return timeZone && dateInTimeZone.isValid ? dateInTimeZone.offsetNameShort : '';
};

export const getTimeZoneLabel = (timeZone: string): string => {
  const dateInTimeZone = DateTime.local().setZone(timeZone);
  const isValid = timeZone && dateInTimeZone.isValid;
  const offset = isValid ? dateInTimeZone.offset / 60 : 0;
  return isValid
    ? `(GMT${offset < 0 ? '' : '+'}${offset}) ${dateInTimeZone.offsetNameLong} ${timeZone.replace('_', ' ')}`
    : '';
};

export const getSimpleTimeZoneList: string[] = Object.values(priorTimeZones);
